<template>  
    <div class="socialmedia">
        <div class="official"></div>
        <div class="member"></div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data(){
        return {
            jaehyunId: '',
            jaehyunPost: [],
        }
    },
    mounted(){
        this.getMemberIGInfo()
    },
    methods:{
        getMemberIGInfo(){
            axios.get('https://www.instagram.com/_jeongjaehyun/?__a=1').then((response) => {
                this.jaehyunId = response.data.graphql.user.id
                this.jaehyunPost =response.data.graphql.user.edge_owner_to_timeline_media.edges
                console.log(response.data)
            })
        },
    }
}
</script>

<style>

</style>